//
import Service from '@/services/api/service'
import PurchaseInvoiceModel from '@/models/Purchase/PchPurchaseInvoice'

/**
 * This class describes a pch purchase invoice.
 *
 * @class      PchPurchaseInvoice (name)
 */
export default class PchPurchaseInvoice extends Service {

  /**
   * Return the pch purchase invoice resource.
   *
   * @return     {Object}  The pch purchase invoice model
   */
  resource() {
    return PurchaseInvoiceModel
  }

  /**
   * Returns a pch purchase invoice list.
   *
   * @return     {Object}  The pch purchase invoice list request.
   */
  toList() {
    return this
      .append('')
      .include(
        'pch_payment_condition',
        'pch_provider',
        //'pch_provider.pch_provider_account',
        //'pch_provider_account_movement.pch_type_provider_account_movement',
        //'pch_provider_account_movement.pch_provider_payment.pch_detail_provider_payment_sheet',
        //'pch_provider_branch_offices.g_commune',
        //'pch_purchase_order_has_invoice_numbers.pch_purchase_order.g_originator_user.hr_employee',
      )
  }
}
